import { createSlice } from "@reduxjs/toolkit";

export const customerSlice = createSlice({
  name: "Customer",
  initialState: {
    user: {},
    orders: [],
    wishlist: [],
    notifications: [
      // {
      //     title: 'Order Shipped',
      //     message: 'Order No. D2P9006 received  by Author',
      //     date: '14 Aug, 2021'
      // },
      // {
      //     title: 'Review Approved',
      //     message: 'Review on HappyGoLucky Approved by Review Panel ',
      //     date: '01 Aug, 2021'
      // }
    ],
  },
  reducers: {
    fetchCustomer: (state, action) => {
      state.user = action.payload;
    },
  },
});

export const { fetchCustomer } = customerSlice.actions;
export default customerSlice.reducer;
